import React from 'react'
import View, {Props} from './View'

export const SuccessDialog = (props: Props) => {
  return <View {...props} />
}
